(() => {
  'use strict';
  if (window.__otStandeeGiftLoaded) return;
  window.__otStandeeGiftLoaded = true;
  const keys = ['Standee gift', 'Standee gift match', 'Standee gift review'];
  const root = window.Shopify?.routes?.root || '/';
  let state = null;
  let pending = false;
  let running = false;
  let timer;
  const attributesFor = (cart, source) => {
    const attributes = Object.fromEntries(keys.map(key => [key, '']));
    const id = Number(source?.dataset.figureId);
    const threshold = Number(source?.dataset.threshold);
    const figure = cart.items?.find(item => Number(item.product_id) === id && item.requires_shipping);
    if (source?.dataset.active !== 'true' || !figure || threshold <= 0 || cart.currency !== source.dataset.currency || cart.total_price < threshold) return attributes;
    attributes[keys[0]] = 'One same-series standee, packed with the figures; verify final eligibility.';
    attributes[keys[1]] = source.dataset.match.slice(0, 200);
    attributes[keys[2]] = `Check final paid merchandise subtotal >= ${(threshold / 100).toFixed(2)} ${cart.currency} and delivery country ${source.dataset.country}; one per order. Source: MainVer0.5.`;
    return attributes;
  };
  const sync = async () => {
    if (running) { pending = true; return; }
    running = true;
    try {
      const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!response.ok) return;
      const cart = await response.json();
      const attributes = attributesFor(cart, state);
      if (keys.some(key => (cart.attributes?.[key] || '') !== attributes[key])) {
        await fetch(`${root}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes })
        });
      }
    } catch {
      document.documentElement.dataset.otStandeeGiftSync = 'pending';
    } finally {
      running = false;
      if (pending) { pending = false; queue(); }
    }
  };
  const queue = () => { clearTimeout(timer); timer = setTimeout(sync, 180); };
  const updateState = node => {
    if (!(node instanceof Element)) return;
    const next = node.matches('[data-ot-standee-state]') ? node : node.querySelector('[data-ot-standee-state]');
    if (next) { state = next; queue(); }
  };
  const observer = new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) updateState(node);
  });
  const start = () => {
    state = document.querySelector('[data-ot-standee-state]');
    observer.observe(document.body, { childList: true, subtree: true });
    queue();
    document.addEventListener('submit', event => {
      if (event.target instanceof HTMLFormElement && event.target.matches('[data-cart-note-navigation-form]')) queue();
    }, true);
    window.addEventListener('pageshow', queue);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
